import { useCallback } from "react";
import { useWeb3React } from "../useWagmiCompat";
import useWeb3 from "../useWeb3";
import { chinaContract } from "../../utils/contractHelpers";
import Environment from "../../utils/Environment";

const useClaimAll = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();

  const tokenAddress = Environment.presaleContract;
  const contract = chinaContract(tokenAddress, web3);

  const claimAll = useCallback(
    async (amount) => {
      if (!account) {
        throw new Error("WALLET_NOT_CONNECTED");
      }

      try {
        return new Promise(async (resolve, reject) => {
          let gas;

          try {
            gas = await contract.methods
              .claimAllTomi(amount)
              .estimateGas({ from: account });
          } catch (err) {
            return reject(err);
          }

          contract.methods
            .claimAllTomi(amount)
            .send({ from: account, gas })

            /* (optional) tx hash */
            .on("transactionHash", (hash) => {
              console.log("ClaimAll tx hash:", hash);
            })

            /* ✅ RESOLVE ONLY ON RECEIPT */
            .on("receipt", (receipt) => {
              console.log("ClaimAll confirmed:", receipt);
              resolve({
                transactionHash: receipt?.transactionHash,
              });
            })

            /* ❌ ERROR */
            .on("error", (error) => {
              console.error("ClaimAll error:", error);
              reject(error);
            });
        });
      } catch (error) {
        throw error;
      }
    },
    [account, contract]
  );

  return { claimAll };
};

export default useClaimAll;

// import { useCallback, useState } from "react";
// import useWeb3 from "../useWeb3";
// import { chinaContract } from "../../utils/contractHelpers";
// import { useWeb3React } from "@web3-react/core";
// import Environment from "../../utils/Environment";

// const ClaimAll = () => {
//   const [balance, setBalance] = useState(null);
//   const { account } = useWeb3React();
//   const web3 = useWeb3();
//   const tokenAddress = Environment.presaleContract;
//   const contract = chinaContract(tokenAddress, web3);

//   const claimAll = useCallback(
//     async (amount) => {
//       try {
//         const gas = await contract.methods.claimAllTomi(amount).estimateGas({
//           from: account,
//         });
//         const details = await contract.methods.claimAllTomi(amount).send({
//           from: account,
//           gas,
//         });
//         return details;
//         // console.log('sdsdss' ,  buy)
//         // return details;
//       } catch (error) {
//         throw error;
//       }
//     },
//     [contract, account]
//   );
//   return { claimAll: claimAll };
// };
// export default ClaimAll;
